if(!customElements.get('custom-cart')){
 class CustomCart extends HTMLElement {
    constructor(){
        super();

        this.init();
    }

    init(){
        this.btnItemRemoves = this.querySelectorAll('.btn-item-remove');
        this.btnItemRemoves.forEach(item => {
            item.addEventListener('click', this.clickItemRemove.bind(this));
        })

        this.cartItems = this.querySelector('.cart-items');
        this.caseDiscountProgress = this.querySelector('.case-discount-progress');
        this.subTotals = this.querySelector('.cart-subtotal');

        this.loading = this.querySelector('.loading');

        this.headerCartLinkWrapper = document.querySelector('custom-header').querySelector('.nav-item--cart');

        this.quantitySelectors = this.querySelectorAll('quantity-selector');
        this.quantitySelectors.forEach(item => {
            var btnRemoveQuantity = item.querySelector('[data-action="remove"]');
            var btnAddQuantity = item.querySelector('[data-action="add"]');
            var input = item.querySelector('.input-quantity');
            btnRemoveQuantity.addEventListener('click', e => {
    if (Number(input.value) === 1) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var removeUrl = btnRemoveQuantity.closest('.cart-item').querySelector('.btn-item-remove a').getAttribute('href');

        this.loading.setAttribute('data-hidden', 'false');
        this.setAttribute('data-loading-status', 'true');

        this.loadCart(removeUrl);
    }
}, true);
            btnRemoveQuantity.addEventListener('mousedown', () => {
            btnRemoveQuantity.dataset.beforeQty = input.value;
            });
            btnRemoveQuantity.addEventListener('click', this.updateQuantity.bind(this));
            btnRemoveQuantity.addEventListener('keydown', e => {
                if(e.key === 'Enter'){
                    this.updateQuantity(e);
                }
            });
            btnAddQuantity.addEventListener('click', this.updateQuantity.bind(this));
            btnAddQuantity.addEventListener('keydown', e => {
                if(e.key === 'Enter'){
                    this.updateQuantity(e);
                }
            });

            input.addEventListener('change', this.updateQuantity.bind(this));
        })

        this.errorMsgs = this.querySelectorAll('.cart-item__errors');

        this.adjustMarginTop();
    }

    refresh(){
        this.init();
    }

    adjustMarginTop(){
        var header = document.querySelector('custom-header');

        if(header){
            const position = window.getComputedStyle(header).position;
            if(position === 'absolute'){
                var headerHeight = header.offsetHeight;
                this.querySelector('.custom-container').style.marginTop = `${ headerHeight }px`;
            }
        }
    }

    updateQuantity(e){
        var btn = e.currentTarget;
        var input = btn.closest('.quantity-wrapper').querySelector('input[name="quantity"]');
var quantity = input.value;


        this.sectionId = this.dataset.id;
        var currentIdx = input.dataset.idx;

        var formData = new FormData();
        formData.append("line", `${currentIdx}`);
        formData.append("quantity", quantity),
        formData.append("sections_url", window.location.pathname);
        formData.append("sections", [this.sectionId]);

        // loading
        this.querySelector(`.cart-item[data-idx="${currentIdx}"] .heading .spinner`).setAttribute('data-loading-status', 'true');

        this.submitToCart(formData, btn, currentIdx);
    }

    getCartSize(){
        const cartItemsIconUrl = `/?section_id=header-cart-icon`;

        fetch(cartItemsIconUrl)
        .then(res => {
            if (!res.ok) {
                var error = new Error(res.status);
                throw error;
            }
      
            return res.text();
        })
        .then((text) => {
            const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-header-cart-icon').innerHTML;

            document.querySelector('custom-header .nav-item .cart-count').innerHTML = resultsMarkup.trim();
            document.querySelector('custom-header .nav-item .cart-count').setAttribute('data-hidden', 'false');
        })
    }

    submitToCart( formData, btn, idx ){

        //config
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        fetch(`${routes.cart_change_url}`, config)
        .then(res => res.json())
        .then(res => {
            // remove all error messages
            this.errorMsgs.forEach(item => {
                item.setAttribute('data-hidden', 'true');
                item.querySelector('.error').innerHTML = '';
            })
            
            if(res.status){
                btn.closest('.cart-item').querySelector('.cart-item__errors .error').innerHTML = `${res.message}`;
                btn.closest('.cart-item').querySelector('.cart-item__errors').setAttribute('data-hidden', 'false');

                // update input
                var currentQuantitySelector = btn.closest('quantity-selector');
                currentQuantitySelector.removeQuantity();

            }else if(res.token){
                this.loadCart(window.location.pathname);
                return;

                const pageText = res.sections[[this.sectionId]];
                const pageHTML = new DOMParser().parseFromString(pageText, 'text/html');

                // update subtotal price
                const cartSummary = pageHTML.querySelector('.cart-summary');
                const subTotals = cartSummary.querySelector('.cart-subtotal');
                this.subTotals.innerHTML = subTotals.innerHTML;

                // update item price
                const cartItem = pageHTML.querySelector(`.cart-item[data-idx="${idx}"]`);

                this.querySelector(`.cart-item[data-idx="${idx}"] .cart-item__final-price`).innerHTML = cartItem.querySelector('.cart-item__final-price').innerHTML;
                this.querySelector(`.cart-item[data-idx="${idx}"] .cart-item__discounts`).innerHTML = cartItem.querySelector('.cart-item__discounts').innerHTML;
                this.querySelector(`.cart-item[data-idx="${idx}"] .cart-item__total-price`).innerHTML = cartItem.querySelector('.cart-item__total-price').innerHTML;

                this.querySelector(`.cart-item[data-idx="${idx}"] .input-quantity`).value = cartItem.querySelector('.input-quantity').value; 
            }

            this.querySelector(`.cart-item[data-idx="${idx}"] .heading .spinner`).setAttribute('data-loading-status', 'false');

            this.getCartSize();

        })
    }

    clickItemRemove(e){
        e.preventDefault();

        var newUrl = e.currentTarget.querySelector('a').getAttribute('href');

        this.loading.setAttribute('data-hidden', 'false');
        this.setAttribute('data-loading-status', 'true');

        this.loadCart(newUrl);
    }

    async loadCart(currentURL){

        try{
            const pageRes = await fetch(
                `${currentURL}`
            );

            const pageText = await pageRes.text();
            const pageHTML = new DOMParser().parseFromString(pageText, 'text/html');

            const cartWrapper = pageHTML.querySelector('custom-cart');

            if(cartWrapper.dataset.numItems == '0'){
                this.innerHTML = cartWrapper.innerHTML;
                this.classList.remove('d-block');
                this.classList.add('d-flex');
                this.classList.add('justify-content-center');
                this.classList.add('align-items-center');
}else{
    this.cartItems.innerHTML = cartWrapper.querySelector('.cart-items').innerHTML;

    const newCaseDiscountProgress = cartWrapper.querySelector('.case-discount-progress');
    if (this.caseDiscountProgress && newCaseDiscountProgress) {
        this.caseDiscountProgress.innerHTML = newCaseDiscountProgress.innerHTML;
    }

    this.subTotals.querySelector('.total-value').innerHTML = cartWrapper.querySelector('.cart-subtotal .total-value').innerHTML;
                this.classList.add('d-block');
                this.classList.remove('d-flex');
                this.classList.remove('justify-content-center');
                this.classList.remove('align-items-center');
            }

            const headerWrapper = pageHTML.querySelector('custom-header');
            const headerCartLinkWrapper = headerWrapper.querySelector('.nav-item--cart');
            this.headerCartLinkWrapper.innerHTML = headerCartLinkWrapper.innerHTML;

            this.refresh();
            
        } catch(error){

            console.error(error);

        } finally {

            this.loading.setAttribute('data-hidden', 'true');
            this.setAttribute('data-loading-status', 'false');

        }
    }
 }

 customElements.define('custom-cart', CustomCart);
}